import styled from "styled-components";
import {GameJackpotBarContainerDefaultBox} from "./game-jackpot-bar-container.default.box";
import {baseColors} from "../../../../../themes/definitions/casino777/base-colors";

export const GameJackpotBarContainerCasino777Box = styled(GameJackpotBarContainerDefaultBox)`
    background: linear-gradient(270deg, ${baseColors.base02} 30.69%, ${baseColors.base01} 153.46%);
    border: 1px solid ${baseColors.base01};
`;

